/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  GetSignedAssetURLForm,
  GetSignedAssetURLForm$Outbound,
  GetSignedAssetURLForm$outboundSchema,
} from "../components/getsignedasseturlform.js";

export type SetProjectLogoSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type SetProjectLogoSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type SetProjectLogoSecurity = {
  option1?: SetProjectLogoSecurityOption1 | undefined;
  option2?: SetProjectLogoSecurityOption2 | undefined;
};

export type SetProjectLogoRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  getSignedAssetURLForm: GetSignedAssetURLForm;
};

/** @internal */
export type SetProjectLogoSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const SetProjectLogoSecurityOption1$outboundSchema: z.ZodMiniType<
  SetProjectLogoSecurityOption1$Outbound,
  SetProjectLogoSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function setProjectLogoSecurityOption1ToJSON(
  setProjectLogoSecurityOption1: SetProjectLogoSecurityOption1,
): string {
  return JSON.stringify(
    SetProjectLogoSecurityOption1$outboundSchema.parse(
      setProjectLogoSecurityOption1,
    ),
  );
}

/** @internal */
export type SetProjectLogoSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const SetProjectLogoSecurityOption2$outboundSchema: z.ZodMiniType<
  SetProjectLogoSecurityOption2$Outbound,
  SetProjectLogoSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function setProjectLogoSecurityOption2ToJSON(
  setProjectLogoSecurityOption2: SetProjectLogoSecurityOption2,
): string {
  return JSON.stringify(
    SetProjectLogoSecurityOption2$outboundSchema.parse(
      setProjectLogoSecurityOption2,
    ),
  );
}

/** @internal */
export type SetProjectLogoSecurity$Outbound = {
  Option1?: SetProjectLogoSecurityOption1$Outbound | undefined;
  Option2?: SetProjectLogoSecurityOption2$Outbound | undefined;
};

/** @internal */
export const SetProjectLogoSecurity$outboundSchema: z.ZodMiniType<
  SetProjectLogoSecurity$Outbound,
  SetProjectLogoSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => SetProjectLogoSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => SetProjectLogoSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function setProjectLogoSecurityToJSON(
  setProjectLogoSecurity: SetProjectLogoSecurity,
): string {
  return JSON.stringify(
    SetProjectLogoSecurity$outboundSchema.parse(setProjectLogoSecurity),
  );
}

/** @internal */
export type SetProjectLogoRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  GetSignedAssetURLForm: GetSignedAssetURLForm$Outbound;
};

/** @internal */
export const SetProjectLogoRequest$outboundSchema: z.ZodMiniType<
  SetProjectLogoRequest$Outbound,
  SetProjectLogoRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    getSignedAssetURLForm: GetSignedAssetURLForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      getSignedAssetURLForm: "GetSignedAssetURLForm",
    });
  }),
);

export function setProjectLogoRequestToJSON(
  setProjectLogoRequest: SetProjectLogoRequest,
): string {
  return JSON.stringify(
    SetProjectLogoRequest$outboundSchema.parse(setProjectLogoRequest),
  );
}
